import SwipeListener from "swipe-listener";

const moreButtons = document.querySelectorAll(".open-nav");
const pageHeader = document.querySelector(".page-header");
const bodyTag = document.querySelector("body");
const hamburgerIcon = document.getElementById('hamburger-icon');

const toggleMenu = pageHeader?.querySelector(".toggle-menu");
const menuWrapper = pageHeader?.querySelector(".menu-wrapper");
const level1Links = pageHeader?.querySelectorAll(".level-1 > li > .nested");
const listWrapper2 = pageHeader?.querySelector(".list-wrapper:nth-child(2)");
const listWrapper3 = pageHeader?.querySelector(".list-wrapper:nth-child(3)");
const backOneLevelBtns = pageHeader?.querySelectorAll(".back-one-level");

const subMenuWrapper2 = listWrapper2?.querySelector(".sub-menu-wrapper");
const subMenuWrapper3 = listWrapper3?.querySelector(".sub-menu-wrapper");

const isVisibleClass = "is-visible";
const isActiveClass = "is-active";

let lastMenuTrigger = null;


// desktop nav: more button
if (moreButtons.length > 0) {
  moreButtons.forEach(button => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      menuWrapper?.classList.add(isVisibleClass);
      hamburgerIcon.classList.add('open');
    });
  });
}

// swipe gesture
const listener = SwipeListener(menuWrapper);
if (menuWrapper) {
  menuWrapper.addEventListener("swipe", (event) => {
	const directions = event.detail.directions;

	if (directions.right) {
      menuWrapper?.classList.toggle(isVisibleClass);
      hamburgerIcon.classList.toggle('open');
	}
  });
}


// Reset everything when menu closes
if (toggleMenu) {
  toggleMenu.addEventListener("click", function () {
    menuWrapper?.classList.toggle(isVisibleClass);
    hamburgerIcon.classList.toggle('open');
    bodyTag.classList.toggle('menu-open');
    
    if (!menuWrapper.classList.contains(isVisibleClass)) {
      listWrapper2?.classList.remove(isVisibleClass);
      listWrapper3?.classList.remove(isVisibleClass);
      
      // Reset all tabindex attributes
      const allMenuLinks = menuWrapper.querySelectorAll("a, button");
      allMenuLinks.forEach(link => {
        if (link.classList.contains('back-one-level')) {
          link.setAttribute('tabindex', '-1');
        } else {
          link.removeAttribute('tabindex');
        }
      });
      
      if (menuWrapper) {
        const menuLinks = menuWrapper.querySelectorAll("a") || [];
        for (const menuLink of menuLinks) {
          menuLink.classList.remove(isActiveClass);
        }
      }
    }
  });
}

// Focus back button when submenu opens
if (level1Links) {
  for (const level1Link of level1Links) {

    // Handle mouse click - opens menu
    level1Link.addEventListener("click", function (event) {
      const siblingList = this.nextElementSibling;
      if (siblingList) {
        event.preventDefault(); // Prevent navigation on click
        lastMenuTrigger = level1Link;
        this.classList.add(isActiveClass);
        const cloneSiblingList = siblingList.cloneNode(true);
        subMenuWrapper2.innerHTML = "";
        subMenuWrapper2.append(cloneSiblingList);
        listWrapper2.classList.add(isVisibleClass);
        
        // Hide level-1
        const level1Wrapper = pageHeader.querySelector(".list-wrapper:nth-child(1)");
        const level1Links = level1Wrapper.querySelectorAll("a, button");
        level1Links.forEach(link => {
          link.setAttribute("tabindex", "-1");
        });
        
        // Focus back button
        setTimeout(() => {
          const backButton = listWrapper2.querySelector('.back-one-level');
          if (backButton) {
            backButton.removeAttribute('tabindex');
            backButton.focus();
          }
        }, 50);
      }
      window.scrollTo({ top: 0, left: 0, behavior: "smooth"});
    });
  }
}

if (listWrapper2) {
  listWrapper2.addEventListener("click", function (event) {
    const target = event.target;
    if (target.tagName.toLowerCase() === "a" && target.nextElementSibling) {
      const siblingList = target.nextElementSibling;
      event.preventDefault();
      target.classList.add(isActiveClass);
      const cloneSiblingList = siblingList.cloneNode(true);
      subMenuWrapper3.innerHTML = "";
      subMenuWrapper3.append(cloneSiblingList);
      listWrapper3.classList.add(isVisibleClass);
    }
  });
}


if(backOneLevelBtns) {
  for (const backOneLevelBtn of backOneLevelBtns) {
    backOneLevelBtn.addEventListener("click", (event) => {
      const parent = event.target.closest(".list-wrapper");
	  if (parent !== null) {
		parent.classList.remove(isVisibleClass);

    // NEW: Restore level-1 focusability when going back
    if (parent === listWrapper2) {
      const level1Wrapper = pageHeader.querySelector(".list-wrapper:nth-child(1)");
      const level1Links = level1Wrapper.querySelectorAll("a, button");
      level1Links.forEach(link => {
        link.removeAttribute("tabindex");
      });

      // Disable level-2 focusability
      const level2Links = listWrapper2.querySelectorAll("a, button");
      level2Links.forEach(link => {
        link.setAttribute("tabindex", "-1");
      });
    }
    
    // NEW: Restore level-2 focusability when going back from level-3
    if (parent === listWrapper3) {
      const level2Links = listWrapper2.querySelectorAll("a, button");
      level2Links.forEach(link => {
        link.removeAttribute("tabindex");
      });
    }

		for (const element of parent.previousElementSibling.getElementsByClassName(isActiveClass)) {
		  element.classList.remove(isActiveClass);
		    }

    if (lastMenuTrigger && document.contains(lastMenuTrigger)) {
      console.log("Focusing back to last menu trigger");
      lastMenuTrigger.focus();
    }
        
  }
    });
  }
}